import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';

@Component
export class CalloutBanner extends ThemeComponent {

}
